/**
 * Medição de rede › Usuário real em apps (R02-07, SDK de Android e iOS): aberturas, telas, requisições, travamentos,
 * ANR e congelamentos por versão do app, sistema, aparelho, rede, operadora e tela. Inglês é a fonte; pt-BR e es têm as
 * mesmas chaves.
 */
const en = {
  'rumm.title': 'Real user on websites and apps',
  'rumm.sub': 'What the visitors of the company websites and the users of its Android and iOS apps really get: load, Core Web Vitals, app start, screens, requests and crashes.',
  'rumm.newApp': 'New app',
  'rumm.tab.app': '{name} (app)',
  'rumm.sdk': 'SDK setup',
  'rumm.sdkHow': 'Add the Android library (sdk/android) or the Swift package (sdk/ios) to the app and start it with this address and key. Integration steps are in the README of each SDK.',
  'rumm.copied': 'Setup code copied.',
  'rumm.by': 'Group by',
  'rumm.by.version': 'App version',
  'rumm.by.os': 'Operating system',
  'rumm.by.device': 'Device model',
  'rumm.by.network': 'Network',
  'rumm.by.carrier': 'Carrier',
  'rumm.by.screen': 'Screen',
  'rumm.kpis': 'App indicators',
  'rumm.sessions': 'Sessions',
  'rumm.crashRate': 'Crashes per session',
  'rumm.crashFree': 'Crash-free users',
  'rumm.crashFree.off': 'user count is off',
  'rumm.users': '{n} users',
  'rumm.cold': 'Cold start p75',
  'rumm.warm': 'Warm start p75',
  'rumm.screenLoad': 'Screen load p75',
  'rumm.request': 'Request p75',
  'rumm.requestErrors': '{pct} with error',
  'rumm.anrHang': 'ANR / hangs',
  'rumm.col.starts': 'Starts (cold/warm)',
  'rumm.col.screens': 'Screen views',
  'rumm.col.requests': 'Requests',
  'rumm.col.errors': 'Request errors',
  'rumm.col.crashes': 'Crashes',
  'rumm.col.anrs': 'ANR',
  'rumm.col.hangs': 'Hangs',
  'rumm.unknown': '(not reported)',
  'rumm.breakdown': 'By {by}',
  'rumm.noData': 'No session in the window',
  'rumm.noDataText': 'Check that the app starts the SDK with the key of this application and that the device is online (the SDK keeps the queue while offline).',
  'rumm.requests': 'Requests by route',
  'rumm.req.route': 'Route',
  'rumm.req.count': 'Calls',
  'rumm.req.errors': 'Errors',
  'rumm.req.p75': 'p75',
  'rumm.req.empty': 'No request measured in the window.',
  'rumm.crashes': 'Crashes, ANR and hangs',
  'rumm.crash.kind': 'Kind',
  'rumm.crash.kind.crash': 'Crash',
  'rumm.crash.kind.anr': 'ANR',
  'rumm.crash.kind.hang': 'Hang',
  'rumm.crash.top': 'Top frame',
  'rumm.crash.topOff': '(top frame not sent)',
  'rumm.crash.version': 'App version',
  'rumm.crash.os': 'System',
  'rumm.crash.count': 'Count',
  'rumm.crash.empty': 'No crash, ANR or hang in the window.',
  'rumm.how': 'p75 = 75% of the measurements were at or below this value. Cold start: the process was not running; warm start: the app came back from the background. An ANR (Android) is the app not answering for 5 s; a hang (iOS) is the main thread blocked, reported by MetricKit.',
  'rumm.disabled': 'This app is turned off: the measurements are refused.',
  'rumm.platform': 'Kind',
  'rumm.platform.web': 'Website',
  'rumm.platform.mobile': 'Android and iOS app',
  'rumm.userIds': 'Count users by the identifier the app sets',
  'rumm.userIdsHint': 'Off by default. When on, the app may call setUserId with an opaque value (never an e-mail or a document number); Hive keeps only a summary (hash) per day to count users and crash-free users.',
  'rumm.privacy': 'No IP, no screen or request content and no person identifier are sent: the request goes as method, host and route template (no query, numbers and ids become {id}); of a crash only the top frame class name (the app can turn it off).',
  'rumm.sample': 'Sample of sessions',
  'rumm.net.wifi': 'Wi-Fi',
  'rumm.net.cellular': 'Cellular',
  'rumm.net.ethernet': 'Ethernet',
  'rumm.net.offline': 'Offline',
  'rumm.net.other': 'Other',
  'rumm.saved': 'App saved.',
};

const ptBR: typeof en = {
  'rumm.title': 'Usuário real nos sites e apps',
  'rumm.sub': 'O que os visitantes dos sites da empresa e os usuários dos apps de Android e iOS realmente recebem: carregamento, Core Web Vitals, abertura do app, telas, requisições e travamentos.',
  'rumm.newApp': 'Novo app',
  'rumm.tab.app': '{name} (app)',
  'rumm.sdk': 'Iniciação do SDK',
  'rumm.sdkHow': 'Inclua a biblioteca de Android (sdk/android) ou o pacote Swift (sdk/ios) no app e inicie com este endereço e esta chave. Os passos estão no README de cada SDK.',
  'rumm.copied': 'Código de iniciação copiado.',
  'rumm.by': 'Agrupar por',
  'rumm.by.version': 'Versão do app',
  'rumm.by.os': 'Sistema operacional',
  'rumm.by.device': 'Modelo do aparelho',
  'rumm.by.network': 'Rede',
  'rumm.by.carrier': 'Operadora',
  'rumm.by.screen': 'Tela',
  'rumm.kpis': 'Indicadores do app',
  'rumm.sessions': 'Sessões',
  'rumm.crashRate': 'Travamentos por sessão',
  'rumm.crashFree': 'Usuários sem travamento',
  'rumm.crashFree.off': 'contagem de usuários desligada',
  'rumm.users': '{n} usuários',
  'rumm.cold': 'Abertura fria p75',
  'rumm.warm': 'Abertura morna p75',
  'rumm.screenLoad': 'Carregamento de tela p75',
  'rumm.request': 'Requisição p75',
  'rumm.requestErrors': '{pct} com erro',
  'rumm.anrHang': 'ANR / congelamentos',
  'rumm.col.starts': 'Aberturas (fria/morna)',
  'rumm.col.screens': 'Telas vistas',
  'rumm.col.requests': 'Requisições',
  'rumm.col.errors': 'Requisições com erro',
  'rumm.col.crashes': 'Travamentos',
  'rumm.col.anrs': 'ANR',
  'rumm.col.hangs': 'Congelamentos',
  'rumm.unknown': '(não informado)',
  'rumm.breakdown': 'Por {by}',
  'rumm.noData': 'Nenhuma sessão na janela',
  'rumm.noDataText': 'Confira se o app inicia o SDK com a chave desta aplicação e se o aparelho tem rede (sem rede o SDK guarda a fila).',
  'rumm.requests': 'Requisições por rota',
  'rumm.req.route': 'Rota',
  'rumm.req.count': 'Chamadas',
  'rumm.req.errors': 'Erros',
  'rumm.req.p75': 'p75',
  'rumm.req.empty': 'Nenhuma requisição medida na janela.',
  'rumm.crashes': 'Travamentos, ANR e congelamentos',
  'rumm.crash.kind': 'Tipo',
  'rumm.crash.kind.crash': 'Travamento',
  'rumm.crash.kind.anr': 'ANR',
  'rumm.crash.kind.hang': 'Congelamento',
  'rumm.crash.top': 'Quadro do topo',
  'rumm.crash.topOff': '(quadro do topo não enviado)',
  'rumm.crash.version': 'Versão do app',
  'rumm.crash.os': 'Sistema',
  'rumm.crash.count': 'Quantidade',
  'rumm.crash.empty': 'Nenhum travamento, ANR ou congelamento na janela.',
  'rumm.how': 'p75 = 75% das medidas ficaram neste valor ou abaixo. Abertura fria: o processo não estava rodando; morna: o app voltou do segundo plano. ANR (Android) é o app sem responder por 5 s; congelamento (iOS) é a linha principal travada, informado pelo MetricKit.',
  'rumm.disabled': 'Este app está desligado: as medidas são recusadas.',
  'rumm.platform': 'Tipo',
  'rumm.platform.web': 'Site',
  'rumm.platform.mobile': 'App de Android e iOS',
  'rumm.userIds': 'Contar usuários pelo identificador que o app definir',
  'rumm.userIdsHint': 'Desligado por padrão. Ligado, o app pode chamar setUserId com um valor opaco (nunca e-mail ou documento); o Hive guarda só um resumo (hash) por dia para contar usuários e usuários sem travamento.',
  'rumm.privacy': 'Não vai IP, conteúdo de tela ou de requisição nem identificador da pessoa: a requisição vai como método, host e modelo da rota (sem query, números e ids viram {id}); do travamento só a classe do quadro do topo (o app pode desligar).',
  'rumm.sample': 'Amostra de sessões',
  'rumm.net.wifi': 'Wi-Fi',
  'rumm.net.cellular': 'Celular',
  'rumm.net.ethernet': 'Cabo',
  'rumm.net.offline': 'Sem rede',
  'rumm.net.other': 'Outra',
  'rumm.saved': 'App salvo.',
};

const es: typeof en = {
  'rumm.title': 'Usuario real en sitios y apps',
  'rumm.sub': 'Lo que los visitantes de los sitios de la empresa y los usuarios de sus apps de Android e iOS reciben realmente: carga, Core Web Vitals, apertura de la app, pantallas, solicitudes y cierres inesperados.',
  'rumm.newApp': 'Nueva app',
  'rumm.tab.app': '{name} (app)',
  'rumm.sdk': 'Inicio del SDK',
  'rumm.sdkHow': 'Agregue la biblioteca de Android (sdk/android) o el paquete Swift (sdk/ios) a la app e inícielo con esta dirección y esta clave. Los pasos están en el README de cada SDK.',
  'rumm.copied': 'Código de inicio copiado.',
  'rumm.by': 'Agrupar por',
  'rumm.by.version': 'Versión de la app',
  'rumm.by.os': 'Sistema operativo',
  'rumm.by.device': 'Modelo del dispositivo',
  'rumm.by.network': 'Red',
  'rumm.by.carrier': 'Operador',
  'rumm.by.screen': 'Pantalla',
  'rumm.kpis': 'Indicadores de la app',
  'rumm.sessions': 'Sesiones',
  'rumm.crashRate': 'Cierres por sesión',
  'rumm.crashFree': 'Usuarios sin cierres',
  'rumm.crashFree.off': 'conteo de usuarios apagado',
  'rumm.users': '{n} usuarios',
  'rumm.cold': 'Apertura en frío p75',
  'rumm.warm': 'Apertura en caliente p75',
  'rumm.screenLoad': 'Carga de pantalla p75',
  'rumm.request': 'Solicitud p75',
  'rumm.requestErrors': '{pct} con error',
  'rumm.anrHang': 'ANR / bloqueos',
  'rumm.col.starts': 'Aperturas (frío/caliente)',
  'rumm.col.screens': 'Pantallas vistas',
  'rumm.col.requests': 'Solicitudes',
  'rumm.col.errors': 'Solicitudes con error',
  'rumm.col.crashes': 'Cierres',
  'rumm.col.anrs': 'ANR',
  'rumm.col.hangs': 'Bloqueos',
  'rumm.unknown': '(no informado)',
  'rumm.breakdown': 'Por {by}',
  'rumm.noData': 'Ninguna sesión en la ventana',
  'rumm.noDataText': 'Verifique que la app inicie el SDK con la clave de esta aplicación y que el dispositivo tenga red (sin red el SDK guarda la cola).',
  'rumm.requests': 'Solicitudes por ruta',
  'rumm.req.route': 'Ruta',
  'rumm.req.count': 'Llamadas',
  'rumm.req.errors': 'Errores',
  'rumm.req.p75': 'p75',
  'rumm.req.empty': 'Ninguna solicitud medida en la ventana.',
  'rumm.crashes': 'Cierres, ANR y bloqueos',
  'rumm.crash.kind': 'Tipo',
  'rumm.crash.kind.crash': 'Cierre',
  'rumm.crash.kind.anr': 'ANR',
  'rumm.crash.kind.hang': 'Bloqueo',
  'rumm.crash.top': 'Marco superior',
  'rumm.crash.topOff': '(marco superior no enviado)',
  'rumm.crash.version': 'Versión de la app',
  'rumm.crash.os': 'Sistema',
  'rumm.crash.count': 'Cantidad',
  'rumm.crash.empty': 'Ningún cierre, ANR o bloqueo en la ventana.',
  'rumm.how': 'p75 = el 75% de las medidas quedó en este valor o por debajo. Apertura en frío: el proceso no estaba en ejecución; en caliente: la app volvió del segundo plano. Un ANR (Android) es la app sin responder por 5 s; un bloqueo (iOS) es el hilo principal trabado, informado por MetricKit.',
  'rumm.disabled': 'Esta app está apagada: las medidas se rechazan.',
  'rumm.platform': 'Tipo',
  'rumm.platform.web': 'Sitio',
  'rumm.platform.mobile': 'App de Android e iOS',
  'rumm.userIds': 'Contar usuarios por el identificador que defina la app',
  'rumm.userIdsHint': 'Apagado por defecto. Encendido, la app puede llamar a setUserId con un valor opaco (nunca un correo o un documento); Hive guarda solo un resumen (hash) por día para contar usuarios y usuarios sin cierres.',
  'rumm.privacy': 'No se envía IP, contenido de pantalla o de solicitud ni identificador de la persona: la solicitud va como método, host y plantilla de ruta (sin query, números e ids se vuelven {id}); del cierre solo la clase del marco superior (la app puede desactivarlo).',
  'rumm.sample': 'Muestra de sesiones',
  'rumm.net.wifi': 'Wi-Fi',
  'rumm.net.cellular': 'Celular',
  'rumm.net.ethernet': 'Cable',
  'rumm.net.offline': 'Sin red',
  'rumm.net.other': 'Otra',
  'rumm.saved': 'App guardada.',
};

export const rumMobileMessages = { en, 'pt-BR': ptBR, es } as const;
